import React from "react";
import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import MyOrders from "./pages/MyOrders";
import Contact from "./pages/Contact";
import { CartProvider } from "./Contexts/CartProvider";

function App() {
  console.log("Developer :-" + "https://github.com/avijitd22");
  return (
    <CartProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/signup" element={<Signup />} />
            <Route exact path="/myorder" element={<MyOrders />} />
            <Route exact path="/contact" element={<Contact />} />
          </Routes>
        </Router>
      </div>
    </CartProvider>
  );
}

export default App;
